import { useBaseStore } from '@roc/feature-app-core';
import { getThirdPartyLoanRoutes, getThirdPartyLoanRoutesConfig } from '../routes/thirdPartyLoanRoutes';

export const useThirdPartyLoanRoutes = () => {
  const { globalStore } = useBaseStore();
  const { routeBasePath, routeBaseUrl } = globalStore;

  return {
    thirdPartyLoanRoutes: getThirdPartyLoanRoutes(routeBasePath, routeBaseUrl),
    thirdPartyLoanRoutesConfig: getThirdPartyLoanRoutesConfig(
      routeBasePath,
      routeBaseUrl
    ),
  };
};
